export default {
      id: "ro-usage",
      viewBox: "0 0 34 34",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#ro",
      toString: function () {
        return this.url;
      }
    }